import { HOT_MODULE_REPLACEMENT } from '../internal/action-types';
export var hotModuleReplacement = function hotModuleReplacement(hotModuleReplacementId) {
  return {
    type: HOT_MODULE_REPLACEMENT,
    hotModuleReplacementId: hotModuleReplacementId
  };
};
//# sourceMappingURL=actions.js.map